/**
 * Notification preferences: pure domain model.
 *
 * The signed-in user's per-channel notification toggles. Persisted per-user
 * (currently in localStorage; see the gateway); the domain stays storage-
 * agnostic. No React/Redux/fetch.
 */
export interface NotifPrefs {
  comment_inapp: boolean;
  list_inapp: boolean;
  list_email: boolean;
}

/** The default preferences for a user who has never changed them. */
export const DEFAULTS: NotifPrefs = {
  comment_inapp: true,
  list_inapp: true,
  list_email: false,
};
